import { createContext } from 'react';
import { useFiltersContext } from '../../../../Common/Filters/hooks/useFiltersContext';
import {
    QUERY_KEYS_VS,
    useChartsData
} from '../../../../Common/hooks/useChartsData';

export const IdentificationChartsDataContext = createContext();

const IdentificationChartsDataProvider = ({ children }) => {
    const { filters } = useFiltersContext();
    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_VS.IDENTIFICATION_LIVE_BIRTHS,
            url: 'governanceroom/dashboard/vitalstatistics/live-births/id'
        },
        {
            data_inicio: filters.data_inicio,
            data_fim: filters.data_fim,
            location: filters.unidade.value,
            city: filters.cidade?.value,
        }
    );

    const chartData = data
        ? {
              indicators: {
                  liveBirths: data?.indicators?.liveBirths ?? 0,
                  liveBirthsWithAnomalies:
                      data?.indicators?.liveBirthsWithAnomalies ?? 0,
                  liveBirthsWithAnomaliesPercentage:
                      data?.indicators?.liveBirthsWithAnomaliesPercentage ?? 0,
                  weightLessThan25kg: data?.indicators?.weightLessThan25kg ?? 0,
                  weightLess25kgxLess6ConsultationsPrenatal:
                      data?.indicators
                          ?.weightLess25kgxLess6ConsultationsPrenatal ?? 0
              },
              apgar1Minute: data?.apgar1Minute ?? [],
              apgar5Minutes: data?.apgar5Minutes ?? [],
              birthWeight: data?.birthWeight ?? [],
              gender: data?.gender ?? []
          }
        : {
              indicators: {
                  liveBirths: 0,
                  liveBirthsWithAnomalies: 0,
                  liveBirthsWithAnomaliesPercentage: 0,
                  weightLessThan25kg: 0,
                  weightLess25kgxLess6ConsultationsPrenatal: 0
              },
              apgar1Minute: [],
              apgar5Minutes: [],
              birthWeight: [],
              gender: []
          };

    return (
        <IdentificationChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </IdentificationChartsDataContext.Provider>
    );
};

export default IdentificationChartsDataProvider;
